angular.module('omfm').directive('emailAddresses', EmailAddressesDirective);

EmailAddressesDirective.$inject = [];

function EmailAddressesDirective() {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {
			addresses: "="
		},
		templateUrl: "/app/omfm/templates/emailAddresses.html",
		link:        function ($scope) {

		}
	}
}